import React from 'react';
import { Button } from "react-bootstrap";
import StarRating from '../../Components/StarRating';
import { IMAGE_PATHS, DOMAIN_URL, base64Encode, base64Decode, formatExperienceDate, toCustomCamelCase, getPerformanceRating } from '../../Functions/Constant';
const UserCard = ({ user, viewUser, rateNow }) => {
    return (
        <div className="p-4 bg-white rounded-lg border-1">
            <div className="text-black">
                <div className="flex items-center h-[60px] sm:h-auto">
                    <img
                    crossorigin="anonymous"
                        src={`${DOMAIN_URL + user.profile_picture}?t=${Date.now()}`}
                        className="w-[50px] h-[50px] rounded-full object-cover border border-gray-300 mr-3"
                        alt="User Avatar"
                    />
                    <div className="flex flex-col">
                        <h3 className="text-[19px] font-bold !mb-0 !leading-[1]">{user.name}</h3>
                        <p className="text-sm text-gray-600 mb-2">
                            {user.profile_title?.length > 40
                                ? `${user.profile_title?.substring(0, 40)}...`
                                : user?.profile_title}
                        </p>
                    </div>
                </div>
                <div className="flex items-center mb-2">
                    <StarRating rating={user.rating} starSize={15} />
                    <span className="ml-2 text-sm">{user.rating}/5 ({(user.total_ratings || user.reviews || 0)}+ reviews)</span>
                </div>
                <ul className="list-disc pl-5 mb-2 text-sm h-[300px] sm:h-[238px] xs:h-[320px]">
                    {user.key_strengths?.length > 0 && (
                        <li>
                            <strong>Top Skills:</strong> {user.key_strengths?.length > 100
                                ? `${user.key_strengths?.substring(0, 100)}...`
                                : user?.key_strengths}
                        </li>
                    )}
                    {user.ai_summary?.length > 0 && (
                        <li>
                            <strong>AI Summary:</strong>
                            {user.ai_summary?.length > 100
                                ? `${user.ai_summary?.substring(0, 100)}...`
                                : user?.ai_summary}
                        </li>
                    )}
                    {user.improvement_areas?.length > 0 && (
                        <li>
                            <strong>Improvement Area:</strong>
                            {user.improvement_areas?.length > 100
                                ? `${user.improvement_areas?.substring(0, 100)}...`
                                : user?.improvement_areas}
                        </li>
                    )}
                    {user.review_summary?.length > 0 && (
                        <li>
                            <strong>Snippet from a review:</strong>
                            {user.review_summary?.length > 100
                                ? `${user.review_summary?.substring(0, 100)}...`
                                : user?.review_summary}
                        </li>
                    )}
                    {user.profile_title?.length > 0 && (
                        <li>
                            <strong>Current Role:</strong> {user.profile_title && user.company_name
                                ? `${user.profile_title} at ${user.company_name}`.length > 100
                                    ? `${user.profile_title} at ${user.company_name}`.substring(0, 100) + "..."
                                    : `${user.profile_title} at ${user.company_name}`
                                : user.profile_title || user.company_name || ""}

                        </li>
                    )}
                </ul>
                <p className="text-sm text-gray-600 mb-2">Curious about how they can help your team succeed?</p>
                <div className="flex justify-center">
                    {user.target_user_id && user.target_user_id > 0 ? (
                        <Button onClick={() => viewUser(user)} className="!mt Krippendorff’s Alpha-2  btn-explore-yellow text-c pd3 dwl kel">
                            View
                        </Button>
                    ) : (
                        <Button onClick={() => rateNow(user)} className="!w-100 btn-explore-white  text-c pd3 kel">
                            verify profile for 1 credit
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserCard;